import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { domainname } from "../config/Config";

const Canonical = () => {
  const location = useLocation();
  const canonicalUrl = `${domainname}${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default Canonical;
